registerGlobal( 'EmscriptenHockeyApp' );

registerGlobal('platform');
platform = require('platform')

var normalizeTitle = function(title, stack) {
    var ret = title.replace("Uncaught ", "");

    if (stack.length) {
        ret += " (" + stack.join(", ") + ")";
    }

    return ret;
}

SourceMapResolver = function() {
    return {
        processStack: function(sourceFile, stack, done, error) {
            this.sourceFileRx = new RegExp("/" + sourceFile + "$");
            this.stack = stack;
            this.done = done;
            this.error = error;
            this.currentFrame = 0;
            this.processedStack = []

            this.resume();
        },

        resume: function() {
            for (var i = this.currentFrame; i < this.stack.length; i++) {
                var sf = this.stack[i];
                if (this.sourceFileRx.test(sf.getFileName())) {
                    if (!this.stackGps) {
                        var ctor = require('stacktrace-gps');
                        this.stackGps = ctor();
                    }

                    var instance = this;

                    this.stackGps.getMappedLocation(sf).then(
                        function(newSf) {
                            instance.processFrame(newSf);
                            instance.currentFrame++;
                            instance.resume();
                        },
                        function(error) {
                            console.log('ERROR WHILE PROCESSING SOURCEMAP:');
                            console.log(error);
                            instance.processFrame(sf);
                            instance.currentFrame++;
                            instance.resume();
                        }
                    );

                    return;
                }

                this.processFrame(sf);
            }

            this.done(this.processedStack);
        },

        processFrame: function(sf) {
            if (sf.getFunctionName()) {
                var fname = sf.getFileName() ? sf.getFileName() + this.normalizeFileNumber(sf.getLineNumber()) + this.normalizeFileNumber(sf.getColumnNumber()) : '';
                var frame = "    at " + sf.getFunctionName() + " (" + fname + ")";

                this.processedStack.push(frame);
            } else {
                this.processedStack.push(sf.getSource());
            }
        },

        normalizeFileNumber: function(n) {
            if (!isNaN(parseFloat(n)) && isFinite(n)) {
                return ":" + n;
            }

            return ""
        }
    }
}

EmscriptenHockeyApp = {
    Init: function(appID, packageName, version) {
        EmscriptenHockeyApp.packageName = packageName;
        EmscriptenHockeyApp.version = version;
        EmscriptenHockeyApp.appID = appID;
    },

    ReportCrash: function(exception) {
        var makeCrashLog = function(exception) {
            var currentDate = new Date();

            var appBinaryFormat = EmInfo.appBinaryFormat ? EmInfo.appBinaryFormat : "asm.js";

            var header = {
                "Package": EmscriptenHockeyApp.packageName,
                "Version": EmscriptenHockeyApp.version + "-" + appBinaryFormat,
                "OS": platform.os,
                "Manufacturer": platform.description,
                "Model": platform.name + " " + platform.version,
                "Date": currentDate.toString(),
                "CrashReporter Key": CookieUtils.getUserID(),
            };

            var result = "";
            for (var property in header) {
                if (header.hasOwnProperty(property)) {
                    result += property;
                    result += ": ";
                    result += header[property];
                    result += "\n";
                }
            }

            if (exception) {
                result += "\n" + exception;
            }
            return result;
        }
        var sendCrashLog = function(exception, retries) {
            retries = (typeof retries !== 'undefined') ? retries : 3;

            var result = makeCrashLog(exception);
            var blob = new Blob([result]);
            var uri = "https://rink.hockeyapp.net/api/2/apps/" + EmscriptenHockeyApp.appID + "/crashes/upload";
            var xhr = new XMLHttpRequest();

            fd = new FormData();
            fd.append('log', blob);
            xhr.open('POST', uri, true);

            xhr.onload = function() {};
            xhr.onerror = function(e) {
                if (retries < 0) return;
                setTimeout(function() {
                    sendCrashLog(exception, retries - 1);
                }, 500);
            };

            xhr.send(fd);
        }

        sendCrashLog(exception);
    },

    HandleStackFrames: function(errorMessage, errorObj, fakeJavaException) {
        var stackFrames = require('error-stack-parser').parse(errorObj);

        smapResolver = SourceMapResolver();
        smapResolver.processStack(
            OUTFILE,
            stackFrames,
            function(newStackFrames) {
                EmscriptenHockeyApp.ProcessStack(newStackFrames, errorMessage, errorObj, fakeJavaException);
            },
            function(error) {
                console.log("Error while resolving sourcemap:");
                console.log(error);

                EmscriptenHockeyApp.HandleErrorMessages(errorMessage, errorObj, fakeJavaException);
            }
        )
    },

    HandleErrorMessages: function(errorMessage, errorObj, fakeJavaException) {
        var lines = null;
        if (errorObj && errorObj.stack) {
            lines = String(errorObj.stack).split('\n');
        } else {
            lines = String(errorMessage).split('\n');
        }

        // remove line with errormsg
        lines.splice(0, 1);

        EmscriptenHockeyApp.ProcessStack(lines, errorMessage, errorObj, fakeJavaException);
    },

    ProcessStack: function(stackFrames, errorMessage, errorObj, fakeJavaException) {
        var isLineInAsm = function(line) {
            //check if line is
            // - inside asm.js
            // - inside VM (no .js extension whatsoever)
            // - inside web-assembly VM
            return line.indexOf("asm.js") != -1 || line.indexOf(".js") == -1 || line.indexOf("wasm-function") != -1;
        }
        var unwasmify = function(line) {
          try
          {
            if (!line.includes("wasm-function")) return line;
            // modify exception line from wasm - leave just pointer to function
            line = line.substring(line.indexOf("wasm-function"));
            regexp = /wasm-function\[([0-9]*)\]:[0-9a-fx]*/;
            line = line.replace(regexp, "  at $1 (src.java:1)");
          }
          catch(e)
          {
            console.log(e);
          }

          return line;
        }

        // Filter out error handling functions
        var blacklist = [
            "at jsStackTrace",
            "at stackTrace",
            "at abort",
            "at abortOnCannotGrowMemory",
            "If this abort",
        ];

        var blacklistReg = new RegExp(blacklist.join("|"));

        stackFrames = stackFrames.filter(function(line, idx) {
            return !blacklistReg.test(line);
        });

        stackFrames = stackFrames.map(function(line) {
            if (!isLineInAsm(line)) return line;
            return line.replace("at Array.", "at ").replace("at Object.", "at ");
        });

        if (fakeJavaException) {
            stackFrames = stackFrames.map(function(line) {
              if (!isLineInAsm(line)) return line;
              line = line.replace(/\(.*\)(\n|$)/g, "(src.java:1)"); // modify context of asm.js binary to indicate java exception
              line = unwasmify(line);
              line = line.replace("  at ", "  at a.");
              return line;
            });
        }

        var trace = [];

        for (var i = 0; i < stackFrames.length; i++) {
            var frame = stackFrames[i];

            var regResult = /at ([^ (]*)[ (]*/.exec(frame);
            if (regResult == null)
                continue;

            var method = regResult[1]; // first substring
            trace.push(method);
        }

        var title = String(errorMessage).split("\n")[0];
        stackFrames.unshift(normalizeTitle(title, trace));

        EmscriptenHockeyApp.ReportCrash(stackFrames.join("\n"));
    },

    HandleCrash: function(errorMessage, errorObj) {
        if (typeof errorObj === "string") {
            errorObj = { stack: errorObj };
        } else if (typeof errorObj === "undefined") {
            errorObj = { stack: errorMessage };
        }

        try {
            EmscriptenHockeyApp.HandleStackFrames(errorMessage, errorObj, true);
        } catch(e) {
            console.log("StackFrame parsing failed, fallback to ErrorMessage");
            console.log(e);
            EmscriptenHockeyApp.HandleErrorMessages(errorMessage, errorObj, true);
        }
    },
};



//////////////////
// WEBPACK FOOTER
// /src/contrib/hockeyapp/src/hockeyapp/emscripten/js/Application.hockeyapp.js
// module id = 37
// module chunks = 0